import { useBrandedVisitorGate } from '#pplx/frontend/apps/ask/hooks/branded-visitor-gate-hooks/useBrandedVisitorGate.js';
import { uploadGateMessages } from '#pplx/frontend/apps/ask/hooks/file-attachments-hooks/uploadGateMessages.js';
import { usePaywallUpsell } from '#pplx/frontend/apps/ask/hooks/pricing-hooks/usePaywallUpsell.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { useFileUploadAnalytics } from '#pplx/frontend/components/hooks/fileUploadAnalytics.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
export function useFileUploadRateLimitPaywall() {
    const { $t } = useIntl();
    const { isPro } = useIsSubscribed();
    const openPaywallUpsell = usePaywallUpsell();
    return useCallback(() => {
        openPaywallUpsell({
            pitchMessage: {
                title: $t(isPro ? uploadGateMessages.proRateLimitTitle : uploadGateMessages.rateLimitTitle),
            },
            origin: isPro ? ModalOrigin.PRO_USER_FILE_UPLOAD_LIMIT : ModalOrigin.FILE_UPLOAD,
        });
    }, [$t, isPro, openPaywallUpsell]);
}
export function useDefaultUploadGate({ checkUploadFile, isFollowUp = false, }) {
    const { $t } = useIntl();
    const isUserLoggedIn = useIsUserLoggedIn();
    const { openVisitorLoginUpsell } = useBrandedVisitorGate({ enabled: !isUserLoggedIn });
    const openRateLimitPaywall = useFileUploadRateLimitPaywall();
    const { rejectInitiation } = useFileUploadAnalytics('thread_attachment');
    const { track } = useInstrumentation();
    return useCallback((sourceType = 'local', { trackRejection = true } = {}) => {
        const result = checkUploadFile();
        if (result.canUpload)
            return null;
        let rejectionCode;
        switch (result.reason) {
            case 'auth':
                openVisitorLoginUpsell({
                    title: $t(uploadGateMessages.authTitle),
                    description: $t(uploadGateMessages.authDescription),
                    origin: ModalOrigin.FILE_UPLOAD,
                    sheetModalVariant: isFollowUp ? 'bottom-sheet-gradient' : 'full-sheet',
                });
                rejectionCode = 'not_signed_in';
                break;
            case 'rate_limit':
                openRateLimitPaywall();
                rejectionCode = 'rate_limited';
                break;
            default:
                assertUnreachableValue(result.reason);
        }
        if (trackRejection) {
            rejectInitiation(undefined, sourceType, rejectionCode).forEach(track);
        }
        return rejectionCode;
    }, [
        checkUploadFile,
        openVisitorLoginUpsell,
        openRateLimitPaywall,
        $t,
        isFollowUp,
        rejectInitiation,
        track,
    ]);
}
//# sourceMappingURL=useDefaultUploadGate.js.map